<template>
  <v-text-field
    :value="value"
    :label="label"
    placeholder="#2F7D0F"
    maxlength="7"
    outlined
    dense
    :rules="rules"
    :error-messages="errorMessages"
    @input="onType"
  >
    <!-- Colored square in front of the hex code -->
    <template v-slot:prepend-inner>
      <span class="color-swatch" :style="{ backgroundColor: swatch }" />
    </template>

    <!-- Color picker -->
    <template v-slot:append>
      <v-menu
        v-model="open"
        :close-on-content-click="false"
        offset-y
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">mdi-palette</v-icon>
        </template>
        <v-color-picker
          :value="swatch"
          mode="hexa"
          hide-mode-switch
          show-swatches
          @input="onPick"
        />
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
const HEX = /^#[0-9a-f]{6}$/i;

export default {
  name: "ColorPickerField",
  props: {
    value: { type: String, default: "#2F7D0F" },
    label: { type: String, default: "Color" },
    errorMessages: { type: [String, Array], default: () => [] },
  },
  data() {
    return {
      open: false,
      rules: [(v) => HEX.test(v || "") || "Use a hex color, for example #2F7D0F"],
    };
  },
  computed: {
    // The picker needs a valid color even while the user is still typing.
    swatch() {
      return HEX.test(this.value || "") ? this.value : "#2F7D0F";
    },
  },
  methods: {
    onType(val) {
      let v = (val || "").trim();
      if (v && v[0] !== "#") v = "#" + v;
      this.$emit("input", v.toUpperCase());
    },
    onPick(val) {
      // The picker can add an alpha part (#RRGGBBAA), only #RRGGBB is stored.
      if (typeof val === "string") {
        this.$emit("input", val.slice(0, 7).toUpperCase());
      }
    },
  },
};
</script>

<style scoped>
.color-swatch {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-top: 2px;
  margin-right: 6px;
  border-radius: 4px;
  border: 1px solid rgba(128, 128, 128, 0.6);
}
</style>
